'use client'
import GithubIcon from '@/icons/GithubIcon'
import GoogleIcon from '@/icons/GoogleIcon'

import { analytics } from '@/lib/analytics'
import { PAGE_PATH } from '@/lib/page-paths'
import { cn } from '@/lib/utils'
import { toast } from 'react-toastify'
import { getAuthorisationURLWithQueryParamsAndSetState } from 'supertokens-web-js/recipe/thirdparty'
import { Button } from '../Button/Button'
import GoldBorderGradient from '../ui/gold-border-gradient'

type ThirdPartyAuthProps = {
  className?: string
}

export default function ThirdPartyAuth({ className }: ThirdPartyAuthProps) {
  const authenticate = async (thirdPartyId: string) => {
    // Track login method click
    analytics.userLifecycle.loginMethodClicked(thirdPartyId)

    try {
      const authRedirect = await getAuthorisationURLWithQueryParamsAndSetState({
        thirdPartyId: thirdPartyId,
        frontendRedirectURI: process.env.NEXT_PUBLIC_APP_URI + PAGE_PATH.CALLBACK,
      })

      window.location.href = authRedirect
    } catch (error) {
      console.error('error', error)
      toast.error('Oops! Something went wrong. Please try again.')
    }
  }

  return (
    <div className={cn('flex w-full flex-col gap-4', className)}>
      <Button
        onClick={() => authenticate('google')}
        variant="dark"
        className="relative flex items-center justify-center gap-4"
      >
        <GoldBorderGradient className="rounded-full" />
        <GoogleIcon className="h-8 w-8" />
        <span>Continue with Google</span>
      </Button>

      <Button
        onClick={() => authenticate('github')}
        variant="dark"
        className="relative flex h-12 items-center justify-center gap-4"
      >
        <GoldBorderGradient className="rounded-full" />
        <GithubIcon className="h-8 w-8" />
        <span>Continue with GitHub</span>
      </Button>
    </div>
  )
}
